export const ForgotPassword = {
  labelForgotPassword: 'Por favor indique o seu e-mail de registo:',
  bottomText: 'Ao clicar no botão Enviar receberá um e-mail com um link de redefinição da sua palavra-passe.',
  checkEmail: 'Queira verificar no endereço de e-mail, por favor.'
}



// WEBPACK FOOTER //
// ./src/translations/pt/views/ForgotPassword.js